const PREVIOUS = "previous";
const NEXT = "next";
export { PREVIOUS, NEXT };
